import type { IQuote } from '@/types/Data'
import type { IDeleteQuote, IGetQuoteList, IPayloadQuote } from '@/types/Request'
import BaseService from '../BaseService'

export default class QuoteServices extends BaseService {
  GetQuoteList(payload: IGetQuoteList) {
    return this.GET<IQuote[]>(this.PATHS.GET_QUOTE_LIST, payload)
  }

  CreateQuote(payload: IPayloadQuote) {
    return this.POST<IQuote>(this.PATHS.CREATE_QUOTE, payload)
  }

  UpdateQuote(payload: IPayloadQuote) {
    return this.PUT<IQuote>(this.PATHS.UPDATE_QUOTE, payload)
  }

  DeleteQuote(payload: IDeleteQuote) {
    return this.DELETE<void>(this.PATHS.DELETE_QUOTE, payload)
  }
}
